export const state = {
    token: JSON.parse(localStorage.getItem('authData'))?.token,
    id: JSON.parse(localStorage.getItem('authData'))?.id,
    refresh_token: JSON.parse(localStorage.getItem('authData'))?.refresh_token,
    email: JSON.parse(localStorage.getItem('authData'))?.email,
    role: JSON.parse(localStorage.getItem('authData'))?.role,
    status: JSON.parse(localStorage.getItem('authData'))?.status,
    user: JSON.parse(localStorage.getItem('authData')),
}; 